import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import PanelLayout from "layouts/PanelLayout";
import "styles/panel.css";

const subjects = [
  {
    id: 1,
    title: "Matematika",
    image: "https://i.ibb.co/RcpCqX9/math.png",
    description: "Matematika testlari to‘plami",
  },
  {
    id: 2,
    title: "Fizika",
    image: "https://i.ibb.co/RcpCqX9/math.png",
    description: "Fizika bo‘yicha mashq testlar",
  },
  {
    id: 3,
    title: "Ingliz tili",
    image: "https://i.ibb.co/RcpCqX9/math.png",
    description: "Grammatika va lug‘at testlari",
  },
];

const StudentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const openSubject = (subject) => {
    navigate(`/student/subject/${subject.title.toLowerCase()}`, {
      state: subject,
    });
  };

  const isMainStudent = location.pathname === "/student";

  return (
    <PanelLayout>
      <Outlet />

      {isMainStudent && (
        <div className="subject_card_wrapper">
          {subjects.map((subject) => (
            <div
              key={subject.id}
              className="subject_card"
              onClick={() => openSubject(subject)}
            >
              <img src={subject.image} alt={subject.title} />
              <h4>{subject.title}</h4>
              <p>{subject.description}</p>
            </div>
          ))}
        </div>
      )}
    </PanelLayout>
  );
};

export default StudentPage;
